import { render, staticRenderFns } from "./mode4h5.vue?vue&type=template&id=18f6fd08&scoped=true"
import script from "./mode4h5.vue?vue&type=script&lang=js"
export * from "./mode4h5.vue?vue&type=script&lang=js"
import style0 from "./mode4h5.vue?vue&type=style&index=0&id=18f6fd08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f6fd08",
  null
  
)

export default component.exports